import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { ApplicationRoutes } from './settings';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';


export const routes: Routes = [
  {
    path: ApplicationRoutes.Auth,
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: ApplicationRoutes.Empty,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  { path: ApplicationRoutes.Unsubscribe, component: UnsubscribeComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
